import { FC, useMemo } from "react";
// 组件
import { ProRadio } from '../antd';
// 方法
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
// 常量
import { RadioGroupProps } from "./interface";

/** 单选按钮组 */
const InterRadioGroup: FC<RadioGroupProps> = props => {
  const { enumCode, options: outOptions, ...restProps } = props;
  const { enumData } = useLayoutContext();
  const options = useMemo(() => {
    if (outOptions) return outOptions;
    if (enumCode && enumData && enumData[enumCode]) {
      return enumData[enumCode].items || [];
    }
  }, [enumCode, outOptions]);
  return (
    <ProRadio.Group
      optionType="button" 
      {...restProps}
      options={options}
    />
  );
};

export default InterRadioGroup;
